var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SFaqList',{class:_vm.variation === _vm.variations.V2 ? 'content-container py-16' : '',attrs:{"id":_vm.id},scopedSlots:_vm._u([{key:"heading",fn:function({ heading }){return [_c('h3',{staticClass:"font--headline-small mb-4"},[_vm._v("\n      "+_vm._s(heading)+"\n    ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }